import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { ContenidoCierreMensual } from "./components/ContenidoCierreMensual";
import "../../../components/Existencia/styles/Existencia.css";

class DetalleCierreMensual extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="CIERRE MENSUAL"
                    subtitulo=""
                    noBorder
                >
                    <ContenidoCierreMensual
                        cierreId={this.props.match.params.id}
                        onRegresar={this.regresar}
                    />
                </Card>
            </div>
        );
    }
}

export default DetalleCierreMensual;
